import { defineMessages } from 'react-intl.macro';

import { EXPORT_TOOL_FORM_TYPE } from '../constants';

export const exportToolMessages = defineMessages({
  // LIST
  exportToolListPageTitle: {
    id: 'exportToolList.PageTitle',
    defaultMessage: 'Přehled exportních nástrojů',
  },
  exportToolListStateWaiting: {
    id: 'exportToolList.state.waiting',
    defaultMessage: 'Seznam exportních nástrojů se načítá.',
  },
  exportToolListStateFail: {
    id: 'exportToolList.state.fail',
    defaultMessage: 'Seznam exportních nástrojů se nepovedlo načíst.',
  },
  exportToolListBtnNew: {
    id: 'exportToolList.btn.new',
    defaultMessage: 'Vytvořit exportní nástroj',
  },
  // COLUMNS / FIELDS
  format: {
    id: 'exportTool.format',
    defaultMessage: 'Formát',
  },
  gpTask: {
    id: 'exportTool.gpTask',
    defaultMessage: 'Exportní nástroj',
  },
  toolName: {
    id: 'exportTool.toolName',
    defaultMessage: 'Název nástroje',
  },
  isDefault: {
    id: 'exportTool.isDefault',
    defaultMessage: 'Výchozí pro formát',
  },
  isPackage: {
    id: 'exportTool.isPackage',
    defaultMessage: 'Balíček',
  },
  parameters: {
    id: 'exportTool.parameters',
    defaultMessage: 'Parametry',
  },
  parameterName: {
    id: 'exportTool.parameter.name',
    defaultMessage: 'Název',
  },
  parameterDataType: {
    id: 'exportTool.parameter.dataType',
    defaultMessage: 'Datový typ',
  },
  parameterValue: {
    id: 'exportTool.parameter.value',
    defaultMessage: 'Hodnota',
  },
});

export const exportToolFormTitleMessages = defineMessages<EXPORT_TOOL_FORM_TYPE>({
  [EXPORT_TOOL_FORM_TYPE.NEW]: {
    id: 'exportToolForm.title.new',
    defaultMessage: 'Nový exportní nástroj',
  },
  [EXPORT_TOOL_FORM_TYPE.EDIT]: {
    id: 'exportToolForm.title.edit',
    defaultMessage: 'Detail exportního nástroje',
  },
});

export const exportToolFormMessages = defineMessages({
  formatErrorMessage: {
    id: 'exportToolForm.format.error',
    defaultMessage: 'Vyberte formát.',
  },
  gpTaskErrorMessage: {
    id: 'exportToolForm.gpTask.error',
    defaultMessage: 'Zadejte exportní nástroj.',
  },
  exportToolAlertDelete: {
    id: 'exportToolForm.alert.delete',
    defaultMessage: 'Opravdu chcete smazat tento exportní nástroj?',
  },
});

export const exportToolFormBtnMessages = defineMessages({
  create: {
    id: 'exportToolForm.btn.create',
    defaultMessage: 'Vytvořit',
  },
  save: {
    id: 'exportToolForm.btn.save',
    defaultMessage: 'Uložit',
  },
  cancel: {
    id: 'exportToolForm.btn.cancel',
    defaultMessage: 'Zrušit změny',
  },
  undo: {
    id: 'exportToolForm.btn.undo',
    defaultMessage: 'Zpět na přehled',
  },
  clear: {
    id: 'exportToolForm.btn.clear',
    defaultMessage: 'Vyčistit',
  },
  delete: {
    id: 'exportToolForm.btn.delete',
    defaultMessage: 'Smazat',
  },
});

export const exportToolFormQueryMessages = defineMessages({
  queryStateWaiting: {
    id: 'exportToolForm.query.waiting',
    defaultMessage: 'Probíhá zpracování.',
  },
  loadQueryStateFail: {
    id: 'exportToolForm.query.loadFail',
    defaultMessage: 'Exportní nástroj se nepodařilo načíst.',
  },
  submitQueryStateSuccess: {
    id: 'exportToolForm.query.submitSuccess',
    defaultMessage: 'Exportní nástroj byl uložen.',
  },
  deleteQueryStateFail: {
    id: 'exportToolForm.query.deleteFail',
    defaultMessage: 'Exportní nástroj se nepodařilo smazat.',
  },
});

export const exportToolFormFailMessages = defineMessages<EXPORT_TOOL_FORM_TYPE>({
  [EXPORT_TOOL_FORM_TYPE.NEW]: {
    id: 'exportToolForm.fail.new',
    defaultMessage: 'Exportní nástroj se nepodařilo vytvořit.',
  },
  [EXPORT_TOOL_FORM_TYPE.EDIT]: {
    id: 'exportToolForm.fail.edit',
    defaultMessage: 'Exportní nástroj se nepodařilo uložit.',
  },
});
